
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, handlePaste } from "../../CommonUtils/CommonValidations";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import * as Yup from 'yup'
import { viewImage } from "../../CommonUtils/viewImage";
import Swal from "sweetalert2";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getDistricts, getDistrictsTest, getMandals, getVillages } from "../../Reducers/AffiliationCommonservice";
import { ApPINCODE, ERROR_MSG, panRegex, PINCODE } from "../../CommonUtils/contextVariables";
import * as bie from "react-bootstrap";
import { ImagePdfBucket } from "../../CommonUtils/ImagesBase64";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import { failureAlert } from "../../CommonUtils/SweetAlerts";
import CommonFormHeading from "../../CommonUtils/CommonFormHeading";

import { FaEye } from "react-icons/fa";

export default function AfflSociety() {

    const districtmst = useSelector((state) => state?.commonMastersReducer?.DistList);
    const headdistrictmst = useSelector((state) => state?.commonMastersReducer?.DistListsAtMultiField);
    const mandalmst = useSelector((state) => state?.commonMastersReducer?.mandalList);
    const headmandalmst = useSelector((state) => state?.commonMastersReducer?.mandalListAtMultiField);
    const villagemst = useSelector((state) => state?.commonMastersReducer?.villageList);
    const headvillagemst = useSelector((state) => state?.commonMastersReducer?.villageListAtMultiField);
    const hasFetchedData = useRef(false)
    const [society, setSociety] = useState([])
    const [data, setData] = useState([])
    const [colData, setColData] = useState([])
    const [flag, setFlag] = useState(false)
    const dispatch = useDispatch();
    const validations = Yup.object().shape({
        society: Yup.string().required(ERROR_MSG)
    })
    const Societyformik = useFormik({
        initialValues: {
            society: ''
        },
        validationSchema: validations,
        enableReinitialize: true,
        onSubmit: (val) => {
            let body = {
                slno: val?.society,
            }
            let url = config.url.API_URL + `societyMapping`
            CommonAxiosPost(url, body, dispatch).then((res) => {
                if (res?.data?.scode === '01') {
                    Swal.fire('Submitted Successfully', '', 'success').then((response) => {
                        if (response?.isConfirmed) {
                            // window.location.reload()
                            GetSocietyList();
                            setFlag(false)

                        }
                    })
                }
                else {
                    failureAlert("Failed to submit")
                }
            })

        }
    })

    const validationSchema = Yup.object().shape({
        societyName: Yup.string().required(ERROR_MSG).nullable(),
        societyDob: Yup.date().required(ERROR_MSG).nullable(),
        societyRegNo: Yup.string().required(ERROR_MSG).nullable(),
        typeOfOrganization: Yup.string().required(ERROR_MSG).nullable(),
        certiRoc: Yup.string().required(ERROR_MSG).nullable(),
        socPan: Yup.string().matches(panRegex, " Invalid Pan No").required(ERROR_MSG).nullable(),
        societyAddr: Yup.string().required(ERROR_MSG).nullable(),
        societyStreet: Yup.string().required(ERROR_MSG).nullable(),
        societyDist: Yup.string().required(ERROR_MSG).nullable(),
        socMandalCode: Yup.string().required(ERROR_MSG).nullable(),
        socVillageCode: Yup.string().required(ERROR_MSG).nullable(),
        societyPincode: Yup.string().required(ERROR_MSG).matches(ApPINCODE, 'Pincode must start with 5'),
        societyMobile: Yup.string().required(ERROR_MSG).matches(/^[6-9]\d{9}$/, 'Invalid Mobile Number'),

        societyPhone: Yup.string().matches(/^[0-9]{8,10}$/, 'Invalid landline number').min(8, "Minimun 8 digits required").max(10, "Maximum 10 digits required").required(ERROR_MSG),

        societyEmail: Yup.string().required(ERROR_MSG).email('Invalid Email'),
        noOfSocietiesInUniversity: Yup.number().required(ERROR_MSG).nullable(),
        socGoveringBodyDate1: Yup.string().required(ERROR_MSG).nullable(),
        socGoveringBodyDate2: Yup.string().required(ERROR_MSG).nullable(),
        socGoveringBodyMeeting1: Yup.string().required(ERROR_MSG).nullable(),
        socGoveringBodyMeeting2: Yup.string().required(ERROR_MSG).nullable(),
        socGoveringMembers: Yup.string().required(ERROR_MSG).nullable(),
        societyHeadName: Yup.string().required(ERROR_MSG).nullable(),
        societyDesignation: Yup.string().required(ERROR_MSG).nullable(),
        socSecyUid: Yup.string().required(ERROR_MSG).nullable(),
        socSecyPan: Yup.string().required(ERROR_MSG).matches(panRegex, 'Invalid PAN'),
        socSecyPhoto: Yup.mixed().required(ERROR_MSG).nullable(),
        societyHeadQualif: Yup.string().required(ERROR_MSG).nullable(),
        societyHeadAddr: Yup.string().required(ERROR_MSG).nullable(),
        societyHeadStreet: Yup.string().required(ERROR_MSG).nullable(),
        societyHeadDist: Yup.string().required(ERROR_MSG).nullable(),
        socHeadMandalCode: Yup.string().required(ERROR_MSG).nullable(),
        socHeadVillageCode: Yup.string().required(ERROR_MSG).nullable(),
        socHeadPincode: Yup.string().required(ERROR_MSG).matches(ApPINCODE, 'Pincode must start with 5 '),
        socHeadPhoneoff: Yup.string().matches(/^[0-9]{8,10}$/, 'Invalid landline number').min(8, "Minimun 8 digits required").max(10, "Maximum 10 digits required").required(ERROR_MSG),

        socHeadMobile: Yup.string().required(ERROR_MSG).matches(/^[6-9]\d{9}$/, 'Invalid Mobile Number'),
        socHeadEmail: Yup.string().required(ERROR_MSG).email('Invalid Email'),
        socHeadChange: Yup.string().required(ERROR_MSG).nullable()
    });


    const mainSocietyformik = useFormik({
        initialValues: {
            societyName: '',
            societyDob: '',
            societyRegNo: '',
            typeOfOrganization: '',
            certiRoc: '',
            socPan: '',
            societyAddr: '',
            societyStreet: '',
            societyDist: '',
            socMandalCode: '',
            socVillageCode: '',
            societyPincode: '',
            societyMobile: '',
            societyPhone: '',
            societyEmail: '',
            noOfSocietiesInUniversity: '',
            socGoveringBodyDate1: '',
            socGoveringBodyDate2: '',
            socGoveringBodyMeeting1: '',
            socGoveringBodyMeeting2: '',
            socGoveringMembers: '',
            societyHeadName: '',
            societyDesignation: '',
            socSecyUid: '',
            socSecyPan: '',
            socSecyPhoto: '',
            societyHeadQualif: '',
            societyHeadAddr: '',
            societyHeadStreet: '',
            societyHeadDist: '',
            socHeadMandalCode: '',
            socHeadVillageCode: '',
            socHeadPincode: '',
            socHeadPhoneoff: '',
            socHeadMobile: '',
            socHeadEmail: '',
            socHeadChange: '',
            changeOfSociety: '',
            socApproveDate: '',
            socProceedings: '',
            latSocApproveDate: '',
            latSocProceedings: '',
            apscheApproveDate: '',
            apscheProceedings: '',
            certiOfIncorporation: '',
            totSocietyLand: '',
        },
        validationSchema: validationSchema,
        onSubmit: (val) => {
            let url = config.url.API_URL + `SocietyDetails`
            CommonAxiosPost(url, val, dispatch).then((res) => {
                if (res?.data?.scode === '01') {
                    Swal.fire(res?.data?.sdesc, '', 'success').then((response) => {
                        if (response?.isConfirmed) {
                            window.location.reload()
                        }
                    })
                }
                else {
                    failureAlert("Failed to submit")

                }
            })

        }
    })
    const Columns = [
        {
            Header: "Sl.no",
            accessor: (row, index) => index + 1,
        },
        {
            Header: <> College <br />Code </>,
            accessor: "coll_code",
        },
        {
            Header: "College Name",
            accessor: "inst_name",
            Cell: ({ row }) => <div style={{ textAlign: "left" }}>{row?.values?.inst_name}</div>

        },

        {
            Header: "Address",
            accessor: "society_add",
        },
        {
            Header: "University",
            accessor: "ub_name",
        },
        {
            Header: "College Phone No",
            accessor: "inst_phone",
        },
        {
            Header: "Society Mapped",
            accessor: "soc_mapped_by",
        },
    ]

    async function GetSocietyList() {
        try {
            const url = `${config.url.API_URL}getsocieties`;
            const res1 = await CommonAxiosGet(url, dispatch);
            setSociety(res1?.data?.scode === '01' ? res1?.data?.societylist : []);
        } catch (error) {
            console.error("Error fetching societies:", error);
            setSociety([]);
        }
        try {
            const url2 = `${config.url.API_URL}getsocietydata`;
            const res2 = await CommonAxiosGet(url2, dispatch);
            setData(res2?.data?.scode === '01' ? res2?.data?.societydata : []);
        } catch (error) {
            console.error("Error fetching society data:", error);
            setData([]);
        }
        try {
            const url3 = `${config.url.API_URL}getsocietyclgs`;
            const res3 = await CommonAxiosGet(url3, dispatch);
            setColData(res3?.data?.scode === '01' ? res3?.data?.societyclgs : []);
        } catch (error) {
            console.error("Error fetching society colleges:", error);
            setColData([]);
        }
    }
    useEffect(() => {
        if (!hasFetchedData.current) {
            GetSocietyList();
            getDistricts();
            getDistrictsTest();
            hasFetchedData.current = true
        }
    }, [])


    const currentYear = moment().year();
    const startOfYear = moment().startOf('year').format('YYYY-MM-DD');
    const today = moment().format('YYYY-MM-DD');
    return (
        <>
            <CommonFormHeading heading="Society Details" />

            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5 "  >
                <FormikProvider value={Societyformik}>
                    <Form onChange={Societyformik?.handleChange} onSubmit={Societyformik?.handleSubmit} className="affl-form">
                        <bie.Row className="px-3 pt-5 m-0" >
                            <bie.Col xs={12} sm={12} md={12} lg={10} xl={6} xxl={6}>
                                <label classname='mb-1'><b style={{ color: 'red' }}>* </b>Find your Society : </label>
                                <Field as="select" name="society" className="form-control" onChange={e => {
                                    setFlag(false)
                                }}>
                                    <option value=''>--SELECT--</option>
                                    {
                                        society && society?.map((ss, i) => (
                                            <option value={ss?.sl_no} key={i}>{ss?.society_name}</option>
                                        ))
                                    }
                                </Field>
                                <ErrorMessage name="society" component="div" className="text-error" />

                            </bie.Col>

                            <bie.Col xs={12} sm={12} md={12} lg={10} xl={3} xxl={3}>
                                <div className="">
                                    <button type='submit' className='btn btn-warning mt-4 mt-xxl-4 affl-warnbtn mt-lg-0'> Click here to Map Society</button>
                                </div>
                            </bie.Col>

                        </bie.Row><br />


                        <bie.Row className="align-items-center px-3">
                            <bie.Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                                <p style={{ fontSize: '19px', color: 'red', marginBottom: 0 }}>
                                    <b>If society is not found in the above List of Societies</b>
                                </p>
                            </bie.Col>

                            <bie.Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                                <button
                                    type="button"
                                    style={{
                                        cursor: 'pointer',
                                        color: 'brown',
                                        fontWeight: 'bold',
                                        marginLeft: '8px',
                                        textDecoration: "underline"
                                    }}
                                    onClick={() => {
                                        setFlag(true);
                                        const container = document.querySelector('.scrollable-container');
                                        if (container) {
                                            container.scrollTo({
                                                top: container.scrollTop + container.clientHeight,
                                                behavior: 'smooth'
                                            });
                                        }
                                    }}
                                >
                                    Click Here to Register & Map the College
                                </button>
                            </bie.Col>
                        </bie.Row>

                        {data.length > 0 && flag == false ? (<>
                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="">Society Registered/Mapped</h1>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>Society Name</th>
                                            <th>Society Registration No.</th>
                                            <th>Date of Registration</th>
                                            <th>Type of the Organisation</th>
                                            <th>Society Registration Certificate</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{ textAlign: "left" }}>{data[0]?.society_name}</td>
                                            <td>{data[0]?.society_reg_no}</td>
                                            <td>{data[0]?.society_dob}</td>
                                            <td>{data[0]?.type_of_organization}</td>
                                            <td style={{ textAlign: 'center' }}><button type='button' className='btn btn-primary' onClick={() => { viewImage(data[0]?.certi_roc) }}>  <FaEye size={25} /></button></td>
                                        </tr>
                                    </tbody>
                                    <thead className="">
                                        <tr>
                                            <th>Chairman/Secretary Name (Mobile No.)</th>
                                            <th>Society District</th>
                                            <th>Mandal</th>
                                            <th>Village</th>
                                            <th>Society Created By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-left">{data[0]?.society_head_name}({data[0]?.society_phone}) </td>
                                            <td>{data[0]?.society_dist}</td>
                                            <td>{data[0]?.soc_mandal_code}</td>
                                            <td>{data[0]?.soc_village_code}</td>
                                            <td>{data[0]?.a_created_by}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </>) : null}
                        {colData.length > 0 && flag == false ? (<>
                            <div className="inner-herbpage-service-title-sub pt-0"  >
                                <h1 className="">List of Colleges under this Society</h1>
                            </div>
                            <CommonReactTable data={colData} columns={Columns} filename="Affl_socety" excelFlag={false} printFlag={false} paginationCount="All" headerName={`List of Colleges under this Society`} />
                        </>) : null}
                    </Form>
                </FormikProvider>
                {flag && (
                    <div className=' mb-3'>
                        <FormikProvider value={mainSocietyformik}>
                            <Form onChange={mainSocietyformik.handleChange} onSubmit={mainSocietyformik.handleSubmit}>
                                <div className="inner-herbpage-service-title-sub"  >
                                    <h1 className="">Name, Details, etc. of the Society should be same as on the Certificate of Incorporation</h1>
                                </div>
                                <div className=''>
                                    <bie.Row className="px-2 pt-2 m-0">
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <span className="label-text-style"> <b style={{ color: 'red' }}>* </b>Society Name  </span> */}
                                            <label classname='mb-1'> <b style={{ color: 'red' }}>* </b>Society Name  </label>
                                            <Field type="text" name="societyName" className="form-control mb-2 " placeholder='Society Name'
                                                onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)} maxLength="200" />
                                            <ErrorMessage name="societyName" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>

                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-3' >
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Date of Registration </label>
                                            <Field type="date" name="societyDob" className="form-control" max={moment().format("YYYY-MM-DD")} onKeyDown={(e) => { e.preventDefault() }} />
                                            <ErrorMessage name="societyDob" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Society Registration No </label>
                                            <Field type="text" name="societyRegNo" className="form-control mb-2 " placeholder='Society Registration No' maxLength="25" />
                                            <ErrorMessage name="societyRegNo" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Type of the Organisation  </label>
                                            <Field as="select" name="typeOfOrganization" className="form-control mb-2 " placeholder='Type of the Organisation ' >
                                                <option value="0">--SELECT--</option>
                                                <option value="1">Trust</option>
                                                <option value="2">Society</option>
                                                <option value="3">Company</option>
                                            </Field>
                                            <ErrorMessage name="typeOfOrganization" component="div" className="text-error" />
                                        </bie.Col>
                                    </bie.Row>
                                    <bie.Row className="px-2 pt-2 m-0  ">
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Society Registration Certificate </label>
                                            <input
                                                type="file" name="certiRoc" className="form-control" accept="application/pdf"
                                                onChange={(e) => {
                                                    let filename = `certiRoc`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/";
                                                    ImagePdfBucket(e, mainSocietyformik, path, `certiRoc`, filename, "pdf");
                                                }}
                                            />

                                            <ErrorMessage name="certiRoc" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>PAN No  </label>
                                            <Field type="text" name="socPan" className="form-control mb-2 " placeholder='PAN No' maxLength='10' onKeyUp={(e) => { mainSocietyformik.setFieldValue("socPan", e.target.value.toUpperCase()) }} />
                                            <ErrorMessage name="socPan" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>House/Door/Flat/Plot No  </label>
                                            <Field type="text" name="societyAddr" className="form-control mb-2 " placeholder='House/Door/Flat/Plot No' maxLength="20" />
                                            <ErrorMessage name="societyAddr" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Street/Road  </label>
                                            <Field type="text" name="societyStreet" className="form-control mb-2 " placeholder='Street/Road ' maxLength="70" />
                                            <ErrorMessage name="societyStreet" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                    </bie.Row>
                                    <bie.Row className="px-2 pt-2 m-0  ">
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>District  </label>
                                            <Field as="select" name="societyDist" className="form-control mb-2 " onChange={(e) => {
                                                getMandals(e.target.value, dispatch);
                                                // getMandalsAtMultiField(e.target.value, dispatch, 'societyDist');
                                                mainSocietyformik?.setFieldValue("socMandalCode", "")
                                                mainSocietyformik?.setFieldValue("socVillageCode", "")
                                            }} >
                                                <option value=''>--SELECT--</option>
                                                {districtmst && districtmst?.map((dd, i) => (
                                                    <option value={dd?.dist_code} key={i}>{dd?.dist_name}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="societyDist" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>

                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Mandal  </label>
                                            <Field as="select" name="socMandalCode" className="form-control mb-2 " onChange={(e) => {
                                                getVillages(mainSocietyformik?.values?.societyDist, e.target.value, dispatch)
                                                Societyformik?.setFieldValue("socVillageCode", "")
                                            }}>
                                                <option value=''>--SELECT--</option>
                                                {mandalmst && mandalmst?.map((mm, i) => (
                                                    <option value={mm?.mandal_code} key={i}>{mm?.mandal_name}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="socMandalCode" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Village   </label>
                                            <Field as="select" name="socVillageCode" className="form-control mb-2 " placeholder='Employee Name'>
                                                <option value=''>--SELECT--</option>
                                                {villagemst && villagemst?.map((vv, i) => (
                                                    <option value={vv?.village_code} key={i}>{vv?.village_name}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="socVillageCode" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Pin Code  </label>
                                            <Field type="text" name="societyPincode" className="form-control mb-2 " placeholder='Pin Code' maxLength='6'
                                                onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="societyPincode" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                    </bie.Row>
                                    <bie.Row className="px-2 pt-2 m-0 ">
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Mobile No.  </label>
                                            <Field type="text" name="societyMobile" className="form-control mb-2 " placeholder='Mobile No.' maxLength='10' onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="societyMobile" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Office Landline(Phone No.)  </label>
                                            <Field type="text" name="societyPhone" className="form-control mb-2 " placeholder='Office Landline(Phone No.)' maxLength='10' onKeyPress={(e) => allowNumbersOnly(e)} />
                                            <ErrorMessage name="societyPhone" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Email ID  </label>
                                            <Field type="text" name="societyEmail" className="form-control mb-2 " placeholder='Email ID' maxLength="40" />
                                            <ErrorMessage name="societyEmail" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>

                                    </bie.Row>
                                    <div className="table-responsive px-3 pt-4">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table table-striped">
                                            <thead>
                                                <tr>
                                                    <th> <b style={{ color: '#fff' }}>* </b>Number of colleges running by the Society in the mandal</th>
                                                    <td>
                                                        <Field type="text" name="noOfSocietiesInUniversity" className="form-control" maxLength="4" placeholder='Number of colleges running by the Society in the mandal' onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} />
                                                        <ErrorMessage name="noOfSocietiesInUniversity" component="div" className="text-error" />
                                                    </td>
                                                    <th> <b style={{ color: '#fff' }}>* </b>Date of Governing Body Meeting Held I (Recent)</th>
                                                    <td>
                                                        <Field type="date" name="socGoveringBodyDate1" className="form-control" min={startOfYear}
                                                            max={today} onKeyDown={(e) => e.preventDefault()} />
                                                        <ErrorMessage name="socGoveringBodyDate1" component="div" className="text-error" />
                                                    </td>

                                                </tr>

                                                <tr>
                                                    <th> <b style={{ color: '#fff' }}>* </b>Date of Governing Body Meeting Held II (Recent)</th>
                                                    <td>
                                                        <Field type="date" name="socGoveringBodyDate2" className="form-control"
                                                            onKeyDown={(e) => { e.preventDefault() }} placeholder='Employee Name'
                                                            min={mainSocietyformik?.values?.socGoveringBodyDate1}

                                                        />
                                                        <ErrorMessage name="socGoveringBodyDate2" component="div" className="text-error" />
                                                    </td>
                                                    <th> <b style={{ color: '#fff' }}>* </b>Governing Body Minutes of Meeting I </th>
                                                    <td>
                                                        <input type="file" name="socGoveringBodyMeeting1" className="form-control" accept="application/pdf"
                                                            onChange={(e) => {
                                                                let filename = 'socGoveringBodyMeeting1';
                                                                let path = "/Uploads/AffiliationPDFs/2023/";
                                                                ImagePdfBucket(e, mainSocietyformik, path, `socGoveringBodyMeeting1`, filename, "pdf");
                                                            }}
                                                        />
                                                        <ErrorMessage name="socGoveringBodyMeeting1" component="div" className="text-error" />
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th> <b style={{ color: '#fff' }}>* </b>Governing Body Minutes of Meeting II</th>
                                                    <td>
                                                        <input type="file" name="socGoveringBodyMeeting2" className="form-control" accept="application/pdf"
                                                            onChange={(e) => {
                                                                let filename = 'socGoveringBodyMeeting2';
                                                                let path = "/Uploads/AffiliationPDFs/2023/Soc_governing/";
                                                                ImagePdfBucket(e, mainSocietyformik, path, `socGoveringBodyMeeting2`, filename, "pdf");
                                                            }}
                                                        />
                                                        <ErrorMessage name="socGoveringBodyMeeting2" component="div" className="text-error" />
                                                    </td>
                                                    <th> <b style={{ color: '#fff' }}>* </b>Upload Governing Body Members List</th>
                                                    <td>
                                                        <input type="file" name="socGoveringMembers" className="form-control" accept="application/pdf"
                                                            onChange={(e) => {
                                                                let filename = 'socGoveringMembers';
                                                                let path = "/Uploads/AffiliationPDFs/2023/Soc_governing/";
                                                                ImagePdfBucket(e, mainSocietyformik, path, `socGoveringMembers`, filename, "pdf");
                                                            }}
                                                        />
                                                        <ErrorMessage name="socGoveringMembers" component="div" className="text-error" />
                                                    </td>

                                                </tr>

                                            </thead>
                                        </table>
                                    </div>
                                </div>
                                <div className="inner-herbpage-service-title-sub">
                                    <h1 className="">Details of Chairman/Secretary</h1>
                                </div>
                                <div className=''>
                                    <bie.Row className="px-2 pt-2 m-0  ">
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Name  </label>
                                            <Field type="text" name="societyHeadName" className="form-control mb-2 " placeholder='Name' onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)} maxLength="40" />
                                            <ErrorMessage name="societyHeadName" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>

                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-3' >
                                            {/* <bie.InputGroup> */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Designation  </label>
                                            <Field type="text" name="societyDesignation" className="form-control" placeholder='Designation' onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)} maxLength="20" />
                                            <ErrorMessage name="societyDesignation" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Aadhar No. </label>
                                            <Field type="text" name="socSecyUid" className="form-control mb-2 " placeholder='Aadhar No.' maxLength='12' onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="socSecyUid" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>PAN No.  </label>
                                            <Field type="text" name="socSecyPan" className="form-control mb-2 " placeholder='PAN No.' maxLength='10' onKeyUp={(e) => { mainSocietyformik.setFieldValue("socSecyPan", e.target.value.toUpperCase()) }} />
                                            <ErrorMessage name="socSecyPan" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                    </bie.Row>
                                    <bie.Row className="px-2 pt-2 m-0  ">
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Upload Photo  </label>
                                            <input type="file" name="socSecyPhoto" className="form-control" accept="image/*"
                                                onChange={(e) => {
                                                    let filename = 'socSecyPhoto';
                                                    let path = "/Uploads/AffiliationPDFs/2023/";
                                                    ImagePdfBucket(e, mainSocietyformik, path, `socSecyPhoto`, filename, "image");
                                                }}
                                            />
                                            <ErrorMessage name="socSecyPhoto" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>

                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-3' >
                                            {/* <bie.InputGroup> */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Educational Qualification </label>
                                            <Field type="text" name="societyHeadQualif" className="form-control" placeholder='Educational Qualification' onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)} maxLength="30" />
                                            <ErrorMessage name="societyHeadQualif" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>House/Door/Flat/Plot No </label>
                                            <Field type="text" name="societyHeadAddr" className="form-control mb-2 " placeholder='House/Door/Flat/Plot No' maxLength="20" />
                                            <ErrorMessage name="societyHeadAddr" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Street/Road  </label>
                                            <Field type="text" name="societyHeadStreet" className="form-control mb-2 " placeholder='Street/Road' maxLength="50" />
                                            <ErrorMessage name="societyHeadStreet" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                    </bie.Row>
                                    <bie.Row className="px-2 pt-2 m-0  ">
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>District   </label>
                                            <Field as="select" name="societyHeadDist" className="form-control mb-2 " onChange={(e) => {
                                                getMandals(e.target.value, dispatch, 'societyHeadDist')
                                                // getMandalsAtMultiField(e.target.value, dispatch, 'societyHeadDist');
                                                mainSocietyformik?.setFieldValue("socHeadMandalCode", "")
                                                mainSocietyformik?.setFieldValue("socHeadVillageCode", "")
                                            }} >
                                                <option value=''>--SELECT--</option>
                                                {headdistrictmst && headdistrictmst.map((dd, i) => (
                                                    <option value={dd?.dist_code} key={i}>{dd?.dist_name}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="societyHeadDist" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>

                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-3' >
                                            {/* <bie.InputGroup> */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Mandal  </label>
                                            <Field as="select" name="socHeadMandalCode" className="form-control" onChange={(e) => {
                                                getVillages(mainSocietyformik?.values?.societyHeadDist, e.target.value, dispatch, "societyDist");
                                                mainSocietyformik?.setFieldValue("socHeadVillageCode", "")
                                            }}>
                                                <option value=''>--SELECT--</option>
                                                {headmandalmst && headmandalmst?.map((mm, i) => (
                                                    <option value={mm?.mandal_code} key={i}>{mm?.mandal_name}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="socHeadMandalCode" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Village  </label>
                                            <Field as="select" name="socHeadVillageCode" className="form-control mb-2 " placeholder='Employee Name' >
                                                <option value=''>--SELECT--</option>
                                                {headvillagemst && headvillagemst?.map((vv, i) => (
                                                    <option value={vv?.village_code} key={i}>{vv?.village_name}</option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name="socHeadVillageCode" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Pin code </label>
                                            <Field type="text" name="socHeadPincode" className="form-control mb-2 " placeholder='Pin code' maxLength='6' onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} />

                                            <ErrorMessage name="socHeadPincode" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                    </bie.Row>
                                    <bie.Row className="px-2 pt-2 m-0  ">
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Office Landline  </label>
                                            <Field type="text" name="socHeadPhoneoff" className="form-control mb-2 " placeholder='Office Landline' maxLength='10' onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="socHeadPhoneoff" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>

                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-3' >
                                            {/* <bie.InputGroup> */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Mobile No. </label>
                                            <Field type="text" name="socHeadMobile" className="form-control" placeholder='Mobile No.' maxLength='10' onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} />
                                            <ErrorMessage name="socHeadMobile" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Email ID </label>
                                            <Field type="text" name="socHeadEmail" className="form-control mb-2 " placeholder='Email ID' maxLength={60} />
                                            <ErrorMessage name="socHeadEmail" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"> <b style={{ color: 'red' }}>* </b>Previous Chairman  </label>
                                            <Field type="text" name="socHeadChange" className="form-control mb-2 " placeholder='Previous Chairman ' onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)} maxLength="40" />
                                            <ErrorMessage name="socHeadChange" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                    </bie.Row>
                                </div><pre /><pre />
                                <button type='submit' className='btn btn-success btn-sm float-end mb-5' >Submit</button><pre /><pre /><pre />
                            </Form>
                        </FormikProvider>
                    </div>
                )}
            </bie.Container >
        </>
    )
}
